/**
 * Article Print — Artemis Therapeutics
 *
 * Generates a clean, branded printable view by cloning article content
 * into a hidden iframe with standalone CSS. This completely bypasses
 * Shopify's CSS cascade (which uses rgba() opacity that prints as faded gray).
 *
 * Called by:
 *  - Print button in social-share.liquid
 *  - Keyboard shortcut Ctrl/Cmd+P (intercepted)
 */
(function () {
  'use strict';

  var PRINT_CSS = [
    '@page {',
    '  size: A4;',
    '  margin: 1.6cm 1.8cm 2cm;',
    '  @bottom-center {',
    '    content: counter(page) " / " counter(pages);',
    '    font-size: 8pt;',
    '    color: #999;',
    '  }',
    '}',
    '',
    '*, *::before, *::after { box-sizing: border-box; }',
    '',
    'body {',
    '  font-family: "Georgia", "Times New Roman", serif;',
    '  font-size: 9.5pt;',
    '  line-height: 1.5;',
    '  color: #1a1a1a;',
    '  background: #fff;',
    '  margin: 0;',
    '  padding: 0;',
    '  -webkit-print-color-adjust: exact;',
    '  print-color-adjust: exact;',
    '}',
    '',
    '/* ── Brand header ── */',
    '.print-header {',
    '  text-align: center;',
    '  padding-bottom: 6pt;',
    '  margin-bottom: 10pt;',
    '  border-bottom: 0.5pt solid #ccc;',
    '}',
    '.print-header__brand {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  letter-spacing: 0.15em;',
    '  text-transform: uppercase;',
    '  color: #888;',
    '}',
    '',
    '/* ── Title ── */',
    'h1 {',
    '  font-family: "Georgia", "Times New Roman", serif;',
    '  font-size: 20pt;',
    '  line-height: 1.15;',
    '  color: #000;',
    '  margin: 0 0 4pt;',
    '  font-weight: 700;',
    '}',
    '',
    '/* ── Metadata ── */',
    '.print-meta {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  color: #555;',
    '  margin-bottom: 2pt;',
    '}',
    '.print-meta span + span::before {',
    '  content: "  \\B7  ";',
    '  color: #bbb;',
    '}',
    '',
    '.print-reviewed {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  color: #2a5a3a;',
    '  font-weight: 500;',
    '  margin-bottom: 10pt;',
    '  padding-bottom: 6pt;',
    '  border-bottom: 0.5pt solid #eee;',
    '}',
    '',
    '/* ── Hero image ── */',
    '.print-hero {',
    '  text-align: center;',
    '  margin-bottom: 10pt;',
    '}',
    '.print-hero img {',
    '  max-width: 100%;',
    '  max-height: 160pt;',
    '  object-fit: cover;',
    '  border-radius: 4pt;',
    '}',
    '',
    '/* ── Article body ── */',
    '.print-body h2 {',
    '  font-family: "Georgia", "Times New Roman", serif;',
    '  font-size: 13pt;',
    '  line-height: 1.2;',
    '  color: #000;',
    '  margin: 14pt 0 4pt;',
    '  page-break-after: avoid;',
    '}',
    '.print-body h3 {',
    '  font-family: "Georgia", "Times New Roman", serif;',
    '  font-size: 11pt;',
    '  line-height: 1.25;',
    '  color: #1a1a1a;',
    '  margin: 10pt 0 3pt;',
    '  page-break-after: avoid;',
    '}',
    '.print-body p {',
    '  margin: 0 0 6pt;',
    '  orphans: 3;',
    '  widows: 3;',
    '  color: #1a1a1a;',
    '}',
    '.print-body ul, .print-body ol {',
    '  margin: 0 0 6pt;',
    '  padding-left: 18pt;',
    '}',
    '.print-body li {',
    '  margin-bottom: 2pt;',
    '  color: #1a1a1a;',
    '}',
    '.print-body strong { font-weight: 700; color: #000; }',
    '.print-body em { font-style: italic; }',
    '',
    '/* ── Links — show external URLs ── */',
    '.print-body a {',
    '  color: #1a1a1a;',
    '  text-decoration: underline;',
    '  text-decoration-color: #999;',
    '}',
    '.print-body a[href^="http"]::after {',
    '  content: " [" attr(href) "]";',
    '  font-size: 6.5pt;',
    '  color: #888;',
    '  word-break: break-all;',
    '  text-decoration: none;',
    '}',
    '.print-body a[href^="/"]::after,',
    '.print-body a[href^="#"]::after,',
    '.print-body sup a::after,',
    '.print-body a[href*="artemistherapeutics"]::after {',
    '  content: none;',
    '}',
    '',
    '/* ── Blockquotes ── */',
    '.print-body blockquote {',
    '  border-left: 2pt solid #ccc;',
    '  margin: 8pt 0;',
    '  padding: 0 0 0 10pt;',
    '  font-style: italic;',
    '  color: #333;',
    '}',
    '',
    '/* ── Tables ── */',
    '.print-body table {',
    '  width: 100%;',
    '  border-collapse: collapse;',
    '  margin: 6pt 0;',
    '  font-size: 8.5pt;',
    '  page-break-inside: avoid;',
    '}',
    '.print-body th, .print-body td {',
    '  border: 0.5pt solid #999;',
    '  padding: 4pt 6pt;',
    '  text-align: left;',
    '  color: #1a1a1a;',
    '}',
    '.print-body th {',
    '  background: #f0f0f0;',
    '  font-weight: 700;',
    '}',
    '',
    '/* ── Images ── */',
    '.print-body img {',
    '  max-width: 100%;',
    '  height: auto;',
    '  page-break-inside: avoid;',
    '  margin: 4pt 0;',
    '}',
    '',
    '/* ── Citations ── */',
    '.print-body sup {',
    '  font-size: 0.7em;',
    '  vertical-align: super;',
    '  line-height: 0;',
    '}',
    '.print-body sup a {',
    '  color: #1a1a1a;',
    '  text-decoration: none;',
    '  font-weight: 700;',
    '}',
    '',
    '/* ── Key Takeaways ── */',
    '.print-takeaways {',
    '  background: #f5f5f2;',
    '  border-left: 3pt solid #2a5a3a;',
    '  padding: 8pt 10pt;',
    '  margin: 8pt 0 10pt;',
    '  page-break-inside: avoid;',
    '}',
    '.print-takeaways h2 {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  font-weight: 700;',
    '  letter-spacing: 0.06em;',
    '  text-transform: uppercase;',
    '  color: #2a5a3a;',
    '  margin: 0 0 6pt;',
    '}',
    '.print-takeaways ul, .print-takeaways ol {',
    '  margin: 0;',
    '  padding-left: 16pt;',
    '}',
    '.print-takeaways li {',
    '  font-size: 9pt;',
    '  margin-bottom: 2pt;',
    '  color: #1a1a1a;',
    '}',
    '',
    '/* ── Practitioner Note ── */',
    '.practitioner-note {',
    '  background: #f5f5f2;',
    '  border: 0.5pt solid #ddd;',
    '  padding: 8pt 10pt;',
    '  margin: 8pt 0;',
    '  page-break-inside: avoid;',
    '}',
    '.practitioner-note::before {',
    '  content: attr(data-label);',
    '  display: block;',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  font-weight: 700;',
    '  letter-spacing: 0.06em;',
    '  text-transform: uppercase;',
    '  color: #2a5a3a;',
    '  margin-bottom: 6pt;',
    '}',
    '.practitioner-note p {',
    '  font-style: italic;',
    '  color: #333;',
    '  margin: 0;',
    '}',
    '',
    '/* ── Glossary terms — inline definitions for print ── */',
    'dfn {',
    '  font-style: normal;',
    '  font-weight: 600;',
    '}',
    'dfn[data-definition]::after {',
    '  content: " (" attr(data-definition) ")";',
    '  font-size: 7.5pt;',
    '  font-weight: 400;',
    '  font-style: italic;',
    '  color: #555;',
    '}',
    '',
    '/* ── Author bio ── */',
    '.print-author {',
    '  border-top: 0.5pt solid #ccc;',
    '  padding-top: 8pt;',
    '  margin-top: 14pt;',
    '  page-break-inside: avoid;',
    '  display: flex;',
    '  gap: 12pt;',
    '  align-items: flex-start;',
    '}',
    '.print-author img {',
    '  width: 36pt;',
    '  height: 36pt;',
    '  border-radius: 50%;',
    '  object-fit: cover;',
    '  flex-shrink: 0;',
    '}',
    '.print-author__name {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 9pt;',
    '  font-weight: 700;',
    '  color: #000;',
    '  margin: 0 0 2pt;',
    '}',
    '.print-author__credentials {',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 8pt;',
    '  color: #555;',
    '  margin: 0 0 4pt;',
    '}',
    '.print-author__bio {',
    '  font-size: 8pt;',
    '  color: #333;',
    '  line-height: 1.5;',
    '  margin: 0;',
    '}',
    '',
    '/* ── FDA disclaimer ── */',
    '.print-disclaimer {',
    '  margin-top: 10pt;',
    '  padding-top: 6pt;',
    '  border-top: 0.5pt solid #ddd;',
    '  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;',
    '  font-size: 7pt;',
    '  color: #999;',
    '  font-style: italic;',
    '  line-height: 1.5;',
    '}',
    '',
    '/* ── Page break helpers ── */',
    'h2, h3, h4 { page-break-after: avoid; }',
    'img, figure, table, blockquote, .print-takeaways, .practitioner-note {',
    '  page-break-inside: avoid;',
    '}',
  ].join('\n');

  // ── Authors data (matches author-bio.liquid) ──
  var AUTHORS = {
    nathalie: {
      name: 'Nathalie Babazadeh',
      credentials: 'Licensed Acupuncturist, Master Herbalist, 18+ years clinical practice',
      url: '/pages/nathalie-babazadeh'
    },
    kacey: {
      name: 'Kacey Moe',
      credentials: 'MS Holistic Nutrition, BS Kinesiology',
      url: '/pages/kacey-moe'
    },
    felix: {
      name: 'Felix Ihno',
      credentials: 'Systems Health Researcher',
      url: '/pages/felix-ihno'
    }
  };

  function getAuthorKey(name) {
    if (!name) return null;
    var n = name.toLowerCase();
    if (n.indexOf('nathalie') >= 0) return 'nathalie';
    if (n.indexOf('kacey') >= 0) return 'kacey';
    if (n.indexOf('felix') >= 0) return 'felix';
    return null;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function buildPrintDocument() {
    // Gather content from the live page
    var title = document.querySelector('.article-template__title');
    var meta = document.querySelector('.article-template__meta');
    var reviewed = document.querySelector('.article-template__reviewed-by');
    var heroImg = document.querySelector('.article-template__hero-container img');
    var content = document.querySelector('.article-template__content');
    var authorBio = document.querySelector('.author-bio');
    var takeaways = document.querySelector('.article-key-takeaways');

    if (!title || !content) return null;

    var html = [];

    // Brand header
    html.push('<div class="print-header">');
    html.push('<div class="print-header__brand">Artemis Therapeutics &nbsp;|&nbsp; artemistherapeutics.com</div>');
    html.push('</div>');

    // Hero image (constrained)
    if (heroImg) {
      html.push('<div class="print-hero">');
      html.push('<img src="' + heroImg.src + '" alt="' + escapeHtml(heroImg.alt || '') + '">');
      html.push('</div>');
    }

    // Title
    html.push('<h1>' + title.innerHTML + '</h1>');

    // Metadata
    if (meta) {
      var metaParts = [];
      var author = meta.querySelector('.article-template__meta-author');
      var date = meta.querySelector('time');
      var readingTime = meta.querySelector('.reading-time');
      var tag = meta.querySelector('.article-template__meta-tag');

      if (author) metaParts.push('<span>' + author.textContent.trim() + '</span>');
      if (date) metaParts.push('<span>' + date.textContent.trim() + '</span>');
      if (readingTime) metaParts.push('<span>' + readingTime.textContent.trim() + '</span>');
      if (tag) metaParts.push('<span>' + tag.textContent.trim() + '</span>');

      if (metaParts.length) {
        html.push('<div class="print-meta">' + metaParts.join('') + '</div>');
      }
    }

    // Reviewed by
    if (reviewed) {
      html.push('<div class="print-reviewed">Reviewed by ' + reviewed.textContent.replace(/^.*Reviewed by\s*/i, '') + '</div>');
    } else {
      // Close the meta section
      html.push('<div style="margin-bottom:14pt;padding-bottom:10pt;border-bottom:0.5pt solid #eee"></div>');
    }

    // Key takeaways
    if (takeaways) {
      html.push('<div class="print-takeaways">');
      html.push(takeaways.innerHTML);
      html.push('</div>');
    }

    // Article body — clone and clean
    var bodyClone = content.cloneNode(true);

    // Remove elements that shouldn't print
    var removeSelectors = [
      '.article-toc-sidebar',
      '.article-heading-anchor',
      '.article-toc',
      '.social-share',
      '.article-email-capture',
      '.table-scroll::after'
    ];
    removeSelectors.forEach(function (sel) {
      bodyClone.querySelectorAll(sel).forEach(function (el) { el.remove(); });
    });

    // Unwrap table-scroll wrappers
    bodyClone.querySelectorAll('.table-scroll').forEach(function (wrapper) {
      var table = wrapper.querySelector('table');
      if (table) wrapper.parentNode.replaceChild(table, wrapper);
    });

    // Process practitioner notes — add label attribute
    bodyClone.querySelectorAll('.practitioner-note').forEach(function (note) {
      var author = note.getAttribute('data-author');
      var label = "Practitioner's Note";
      if (author === 'nathalie') label += ' \u2014 Nathalie Babazadeh, L.Ac.';
      else if (author === 'kacey') label += ' \u2014 Kacey Moe, MS';
      else if (author === 'felix') label += ' \u2014 Felix Ihno';
      note.setAttribute('data-label', label);
    });

    html.push('<div class="print-body">');
    html.push(bodyClone.innerHTML);
    html.push('</div>');

    // Author bio
    if (authorBio) {
      var authorName = authorBio.querySelector('.author-bio__name');
      var authorCreds = authorBio.querySelector('.author-bio__credentials');
      var authorText = authorBio.querySelector('.author-bio__text');
      var authorImg = authorBio.querySelector('.author-bio__photo img, .author-bio__photo');

      html.push('<div class="print-author">');
      if (authorImg && authorImg.src) {
        html.push('<img src="' + authorImg.src + '" alt="">');
      }
      html.push('<div>');
      if (authorName) html.push('<p class="print-author__name">' + authorName.textContent.trim() + '</p>');
      if (authorCreds) html.push('<p class="print-author__credentials">' + authorCreds.textContent.trim() + '</p>');
      if (authorText) html.push('<p class="print-author__bio">' + authorText.textContent.trim() + '</p>');
      html.push('</div>');
      html.push('</div>');
    }

    // FDA disclaimer
    html.push('<div class="print-disclaimer">');
    html.push('These statements have not been evaluated by the Food and Drug Administration. ');
    html.push('This product is not intended to diagnose, treat, cure, or prevent any disease. ');
    html.push('For educational purposes only. Consult your healthcare provider before making changes to your wellness protocol. ');
    html.push('&copy; Artemis Therapeutics &mdash; artemistherapeutics.com');
    html.push('</div>');

    return html.join('\n');
  }

  function printArticle() {
    var content = buildPrintDocument();
    if (!content) {
      window.print(); // Fallback
      return;
    }

    // Create hidden iframe
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:210mm;height:297mm;border:none;';
    document.body.appendChild(iframe);

    var doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write([
      '<!DOCTYPE html>',
      '<html lang="en">',
      '<head>',
      '<meta charset="utf-8">',
      '<title>' + escapeHtml(document.querySelector('.article-template__title')?.textContent || 'Article') + ' — Artemis Therapeutics</title>',
      '<style>' + PRINT_CSS + '</style>',
      '</head>',
      '<body>',
      content,
      '</body>',
      '</html>'
    ].join('\n'));
    doc.close();

    // Wait for images to load, then print
    var images = doc.querySelectorAll('img');
    var loaded = 0;
    var total = images.length;

    function doPrint() {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      // Clean up after print dialog closes
      setTimeout(function () {
        document.body.removeChild(iframe);
      }, 1000);
    }

    if (total === 0) {
      setTimeout(doPrint, 100);
    } else {
      images.forEach(function (img) {
        if (img.complete) {
          loaded++;
          if (loaded >= total) setTimeout(doPrint, 100);
        } else {
          img.addEventListener('load', function () {
            loaded++;
            if (loaded >= total) setTimeout(doPrint, 100);
          });
          img.addEventListener('error', function () {
            loaded++;
            if (loaded >= total) setTimeout(doPrint, 100);
          });
        }
      });
      // Safety timeout — print after 3s even if images haven't loaded
      setTimeout(doPrint, 3000);
    }
  }

  // Expose globally
  window.artemisArticlePrint = printArticle;

  // Intercept Cmd/Ctrl+P on article pages
  if (document.querySelector('.article-template__content')) {
    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'p') {
        e.preventDefault();
        printArticle();
      }
    });
  }
})();
